angular.module('rjmNg.directives').directive "referenceEditor", [
  "columnErrorService"
  (
    columnErrorService
  ) ->
    restrict: "E"
    templateUrl: "directive.referenceEditor.html"
    replace: false
    scope:
      activeTableId: "="
      columnDefinition: "="
      enabled: "=?"
      referenceToLocalTable: "="
    controllerAs: 'view'
    bindToController: true
    controller: [
      "logger"
      "Reference"
      "StructureCache"
      "notification"
      "$rootScope"
      (
        logger
        Reference
        StructureCache
        notification
        $rootScope
      ) ->

        view = @

        view.loading = false
        view.structure = null

        # Initialize local state
        view.to =
          table: null
          column: null
        view.from =
          table: null
          column: null

        view.notReadyToSave = true

        autoSelectLocalTable = () ->
          return unless view.activeTableId? and
            view.structure? and
            view.structure.tables[view.activeTableId]?

          view[view.localTable].table = view.activeTableId

        structureQuerySuccess = (structure) ->
          view.structure = structure
          autoSelectLocalTable()
          view.loading = false

        structureQueryError = (error) ->
          notification.error(
            "Server Error"
            "Error loading structure/references."
            "global"
            error
          )
          view.loading = false

        showGenericError = () ->
          notification.error "Server Error", "There was an error saving this path", "global"

        relocatedFieldPath =
          title: "Can't create path:"
          message: "Joined columns from other tables can't be used in paths."

        selfJoinError =
          title: "Self-join is not allowed!"
          message: "You cannot define JOIN path between columns of the same table."

        # Save this new relation
        view.save = () ->

          reference = new Reference(view.from, view.to, view.structure)
          if reference?
            reference.save().then (success) ->
              # Repopulate the cache
              StructureCache.getStructureAndReferences(true).then (success) ->
                $rootScope.$broadcast 'structureCacheUpdated'
              view.enabled = false

              logger.log('Reference Editor', 'Save', 1, 'create')
              notification.success "Success", "Successfully added path", "global"
            ,  (error) ->
              errorType = typeof(error)
              if 'string' is errorType
                message = error
              else
                message = columnErrorService.get(error.data?.errors)

              message += " <span class='rj-notification__additional-info'> Help Center Article: <a href='https://support.rjmetrics.com/hc/en-us/articles/207198056-Creating-paths-for-calculated-columns#limits' target='_blank'>Limitations of Creating Paths</a></span>"
              notification.error "Server Error", message, "global"
          else
            showGenericError()

        # If we bind enabled to the parent, it should hide the editor
        view.cancel = () ->
          view.enabled = false

        isRelocatedField = (columnId) ->
          'relocated_field' is view?.structure?.columns[columnId]?.properties?.derivative_type

        view.verify = () ->
          if view.to.table is view.from.table and !(view.to.table is null) and !(view.from.table is null)
            view.error = selfJoinError
          else if isRelocatedField(view.from.column) or isRelocatedField(view.to.column)
            view.error = relocatedFieldPath
          else
            view.error = null
          view.notReadyToSave = view.to.column is null or view.from.column is null or view.error

          $rootScope.$broadcast "updateColumnsSelectionRestrictions",
            to: view.to
            from: view.from

        @$onInit = ->
          if view.referenceToLocalTable
            view.localTable = 'to'
            view.otherTable = 'from'
          else
            view.localTable = 'from'
            view.otherTable = 'to'

          view.loading = true
          StructureCache.getStructure().then(
            structureQuerySuccess
            structureQueryError
          )

          # Send this to the journal
          logger.log('Reference Editor', 'Open', 1, 'create')

        view
    ]
    link: (scope, element, attributes, view) ->

      scope.$watchGroup [
        'view.to.table'
        'view.from.table'
        'view.to.column'
        'view.from.column']
        ,
        view.verify

]
